import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
import { useLocation, Link } from 'react-router-dom';
export function EvaSchiffererInfoPage() {
  const location = useLocation();
  useEffect(() => {
    // Prüfen, ob ein Hash in der URL vorhanden ist und zu diesem Element scrollen
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, [location]);
  return <div className="min-h-screen bg-white" data-id="element-1285">
      <Header data-id="element-1286" />
      <main className="w-full pt-[152px]" data-id="element-1287">
        {/* Hero Section mit Bild */}
        <div className="w-full flex justify-center" data-id="element-1288">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1289">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b4xGixPk9gzEoJmDrVv6Nu/Header-Info-Eva_Schifferer.jpg" alt="Eva Sophie Schifferer im Gespräch" className="w-full h-full object-cover" data-id="element-1290" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1291"></div>
          </div>
        </div>
        {/* Hauptinhalt */}
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1292">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1293">
            Info
          </h1>
          {/* Terminbuchung Section */}
          <section id="terminbuchung" className="mb-16 scroll-mt-[180px]" data-id="element-1294">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1295">
              Terminbuchung
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-1296">
              <p className="mb-6" data-id="element-1297">
                <strong data-id="element-1298">Wie finden wir zusammen:</strong>
              </p>
              <div className="mb-6 flex flex-col md:flex-row md:items-center gap-4" data-id="element-1299">
                <span data-id="element-1300">Sie kontaktieren mich über</span>
                <Link to="/eva_schifferer/termin-vereinbaren" data-id="element-1301">
                  <button className="py-2 px-5 bg-blue-100 text-gray-700 rounded-md hover:bg-[#c2cde0] hover:font-semibold transition-colors" data-id="element-1302">
                    Termin vereinbaren
                  </button>
                </Link>
                <span data-id="element-1303">
                  oder schreiben eine{' '}
                  <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1304">
                    Mail
                  </a>
                </span>
              </div>
            </div>
            <div className="space-y-6" data-id="element-1305">
              <div className="flex items-start" data-id="element-1306">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1307"></div>
                <p className="text-lg text-gray-600" data-id="element-1308">
                  Wir verabreden einen ungefähr 30-minütigen kostenfreien
                  Kennenlern-Termin, um die persönliche Chemie zu klären, eine
                  mögliche Beratung oder Psychotherapie für Sie anfassbar zu
                  machen und nächste Schritte zu besprechen.
                </p>
              </div>
              <div className="flex items-start" data-id="element-1309">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1310"></div>
                <p className="text-lg text-gray-600" data-id="element-1311">
                  Die Termine finden in meiner Praxis im Frankfurter Nordend
                  statt, bei einem Spaziergang (auch z.B. während Ihrer
                  Mittagspause) oder virtuell über Teams oder Zoom. Sowohl in
                  englischer als auch deutscher Sprache als auch
                  Terminvereinbarung am Wochenende möglich!
                </p>
              </div>
              <div className="flex items-start" data-id="element-1312">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1313"></div>
                <p className="text-lg text-gray-600" data-id="element-1314">
                  Verlässliche Begleitung: Ich arbeite nicht mit festen
                  Programmen oder Paketlösungen. Stattdessen gestalte ich die
                  Zusammenarbeit individuell – so lange, wie sie sinnvoll,
                  hilfreich und wirksam ist.
                </p>
              </div>
            </div>
          </section>
          {/* Konditionen Section */}
          <section id="konditionen" className="mb-16 scroll-mt-[180px]" data-id="element-1315">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1316">
              Konditionen
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-8" data-id="element-1317">
              <p data-id="element-1318">
                Als Heilpraktikerin für Psychotherapie führe ich eine
                Privatpraxis, und Sie tragen die Kosten in der Regel selber –
                eine Abrechnung über die gesetzliche Krankenkasse ist nicht
                möglich. Heilkundliche Tätigkeit ist von der Umsatzsteuer gemäß
                § 4 Nr. 14 UStG befreit. Aus diesem Grund erheben wir für
                Psychotherapie nach dem Heilpraktikergesetz keine Umsatzsteuer
                und weisen diese folglich auch nicht aus.
              </p>
              <div data-id="element-1319">
                <h3 className="text-xl font-medium text-gray-700 mb-3" data-id="element-1320">
                  Selbstzahler/Privatzahler:
                </h3>
                <p data-id="element-1321">
                  Als Selbstzahler*Innen entfällt die Beantragung der
                  Kostenerstattung sowie die Diagnosestellung für die
                  Krankenkasse. Aufgrund meiner Schweigepflicht gelangen keine
                  Informationen an Dritte wie etwa Krankenkassen,
                  Rentenversicherungen oder Berufsgenossenschaften. Dies kann
                  z.B. im Zusammenhang mit Risikozuschlägen oder
                  Gesundheitsprüfungen (z.B. Lebensversicherungen) von Vorteil
                  sein. Die Kosten für Psychotherapie können als
                  außergewöhnliche Belastung bei der Einkommensteuererklärung
                  geltend gemacht werden. Ebenso kann die Therapie kurzfristig
                  ohne lange Wartezeiten starten.
                </p>
              </div>
              <div data-id="element-1322">
                <h3 className="text-xl font-medium text-gray-700 mb-3" data-id="element-1323">
                  Privat Versicherte:
                </h3>
                <p data-id="element-1324">
                  Viele private Krankenversicherungen erstatten die Kosten voll
                  oder zum Teil. Die Voraussetzung für die Kostenerstattung, die
                  Anzahl der erstattungsfähigen Sitzungen und die Höhe der
                  erstatteten Sätze variiert jedoch stark zwischen den privaten
                  Krankenversicherungen und hängt ebenso von Ihrem individuellen
                  Tarif ab. Bitte klären Sie daher zuvor mit Ihrer
                  Krankenversicherung ab, welche psychotherapeutischen
                  Leistungen übernommen werden.
                </p>
              </div>
              <p data-id="element-1325">
                Die Kosten für Paartherapie/ -beratung werden leider weder von
                gesetzlichen noch privaten Krankenversicherungen erstattet.
              </p>
              <p data-id="element-1326">
                Manchmal ist der Bedarf groß – aber die finanziellen
                Möglichkeiten begrenzt. Deshalb halte ich zwei Therapie- bzw.
                Beratungsplätze zu einem deutlich reduzierten Honorar bereit –
                zum Beispiel für Studierende, Menschen in Übergangsphasen oder
                bei finanziellen Engpässen.
              </p>
              <p data-id="element-1327">
                Melden Sie sich gern – wir klären gemeinsam, ob ein Platz
                verfügbar ist.
              </p>
            </div>
            <div className="overflow-x-auto mb-8" data-id="element-1328">
              <table className="w-full border-collapse" data-id="element-1329">
                <tbody data-id="element-1330">
                  <tr className="border-b border-gray-200" data-id="element-1331">
                    <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-1332">
                      30-minütiges Kennenlern-Gespräch (oder Telefonat)
                    </td>
                    <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-1333">
                      Kostenfrei
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-1334">
                    <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-1335">
                      Paartherapie 90 Minuten
                    </td>
                    <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-1336">
                      225 EUR incl. MwSt
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-1337">
                    <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-1338">
                      Paarberatung 90 Minuten
                    </td>
                    <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-1339">
                      225 EUR incl. MwSt
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-1340">
                    <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-1341">
                      Einzelcoaching
                    </td>
                    <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-1342">
                      139 EUR incl. MwSt
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-1343">
                    <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-1344">
                      Intensiv-Beratung am Wochenende
                    </td>
                    <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-1345">
                      Nach Vereinbarung
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-1346">
                    <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-1347">
                      Einzeltherapie
                    </td>
                    <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-1348">
                      120 EUR
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="space-y-6 text-lg text-gray-600" data-id="element-1349">
              <p data-id="element-1350">
                Bitte beachten Sie: Ihren Termin können Sie bar im Anschluss an
                den Termin oder via EC-Karte bezahlen.
              </p>
              <div data-id="element-1351">
                <h3 className="text-xl font-medium text-gray-700 mb-3" data-id="element-1352">
                  Terminabsagen:
                </h3>
                <p className="mb-3" data-id="element-1353">
                  Verbindlichkeit ist mir in der Zusammenarbeit sehr wichtig.
                  Termine halte ich für Sie reserviert und kann diese bei
                  kurzfristigen Absagen nicht mehr anderweitig vergeben. Deshalb
                  gelten folgende Stornoregelungen:
                </p>
                <div className="space-y-2" data-id="element-1354">
                  <div className="flex items-start" data-id="element-1355">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1356"></div>
                    <p className="text-gray-600" data-id="element-1357">
                      Absagen bis zu 48 Stunden vor ihrem gebuchten Termin sind
                      kostenfrei.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-1358">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1359"></div>
                    <p className="text-gray-600" data-id="element-1360">
                      Für Absagen weniger als 48 Stunden vor dem Termin berechne
                      ich 60 % Stornokosten.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-1361">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1362"></div>
                    <p className="text-gray-600" data-id="element-1363">
                      Für Absagen weniger als 24h vor dem Termin berechne ich
                      100% Stornokosten.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-1364">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1365"></div>
                    <p className="text-gray-600" data-id="element-1366">
                      Bei kurzfristiger Absage aufgrund akuter Erkrankung kann
                      nach Vorlage eines ärztlichen Attests auf das
                      Ausfallhonorar verzichtet werden
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-1367">
                <h3 className="text-xl font-medium text-gray-700 mb-3" data-id="element-1368">
                  Schweigepflicht
                </h3>
                <p data-id="element-1369">
                  Wir unterliegen der Schweigepflicht. Selbstverständlich werden
                  sämtliche Inhalte der Therapie sowie Ihre persönlichen Daten
                  diskret und streng vertraulich behandelt.
                </p>
              </div>
            </div>
          </section>
          {/* Anfahrtsskizze Section */}
          <section id="anfahrt" className="mb-16 scroll-mt-[180px]" data-id="element-1370">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1371">
              Anfahrtsskizze
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed" data-id="element-1372">
              <p className="mb-4" data-id="element-1373">Zentral gelegen im Frankfurter Nordend:</p>
              <div className="space-y-2 mt-4" data-id="element-1374">
                <div className="bg-gray-50 p-5 rounded-lg" data-id="element-1375">
                  <h3 className="text-xl font-medium text-gray-700 mb-2" data-id="element-1376">
                    Vom Frankfurter Hauptbahnhof
                  </h3>
                  <div className="space-y-2" data-id="element-1377">
                    <div className="flex items-start" data-id="element-1378">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1379"></div>
                      <p className="text-gray-600" data-id="element-1380">
                        Straßenbahnlinie 18 Richtung Preungesheim: Ausstieg an
                        Haltestelle Friedberger Landstraße (ca. 5–7 Minuten
                        Fußweg zur Rohrbachstraße 35)
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-1381">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1382"></div>
                      <p className="text-gray-600" data-id="element-1383">
                        U-Bahn U4 oder U5 bis Bornheim Mitte (ca. 8–10 Minuten
                        Fußweg zur Rohrbachstraße 35)
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-5 rounded-lg" data-id="element-1384">
                  <h3 className="text-xl font-medium text-gray-700 mb-2" data-id="element-1385">
                    Anfahrt mit dem Auto
                  </h3>
                  <p className="mb-3" data-id="element-1386">
                    Über die Friedberger Landstraße und Nibelungen- oder
                    Rothschildallee in die Rohrbachstraße abbiegen.
                  </p>
                  <h4 className="text-lg font-medium text-gray-700 mb-2" data-id="element-1387">
                    Parkmöglichkeiten:
                  </h4>
                  <div className="space-y-2" data-id="element-1388">
                    <div className="flex items-start" data-id="element-1389">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1390"></div>
                      <p className="text-gray-600" data-id="element-1391">
                        Parkmöglichkeiten befinden sich tagsüber entlang der
                        Rohrbachstraße und den umliegenden Straßen
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-1392">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1393"></div>
                      <p className="text-gray-600" data-id="element-1394">
                        Parkhaus Bürgerhaus Bornheim (Arnsburger Str. 24) ca.
                        1,0 km, etwa 12 Minuten zu Fuß
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-1395">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1396"></div>
                      <p className="text-gray-600" data-id="element-1397">
                        Parkhaus Mousonturm (Waldschmidtstraße 4) ca. 1,2 km,
                        etwa 15 Minuten zu Fuß
                      </p>
                    </div>
                  </div>
                  <p className="mt-4 font-semibold text-gray-700" data-id="element-1398">
                    Bitte klingeln Sie bei Studio Connect.
                  </p>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-1399">
                <p className="text-gray-600" data-id="element-1400">
                  Appointments are also possible in English. Please contact me
                  via{' '}
                  <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1401">
                    email
                  </a>{' '}
                  for sessions in English!
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <EvaSchiffererFooter data-id="element-1402" />
    </div>;
}